import getLastViewed from '@/api/getLastViewed';
import getMostPopular from '@/api/getMostPopular';
import getMultipleSkus from '@/api/getMultipleSkus';
import { useQuery } from '@tanstack/react-query';

function useFetchMultipleSkus(slugs: string[]) {
  const skusQuery = useQuery({
    queryKey: ['sku/multiple', slugs],
    queryFn: ({ queryKey }) =>
      getMultipleSkus(
        queryKey[1] as string[],
        Number((queryKey[1] as string[]).length)
      ),
  });

  return skusQuery;
}

function useFetchLastViewed() {
  const data = useQuery({
    queryKey: ['sku/last-viewed'],
    queryFn: getLastViewed,
  });

  return data;
}

function useFetchMostPopular() {
  const data = useQuery({
    queryKey: ['mostPopular'],
    queryFn: getMostPopular,
  });

  return data;
}

export { useFetchMultipleSkus, useFetchLastViewed, useFetchMostPopular };
